<app-card>
  <form [formGroup]="searchForm">
    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'vee.meteringpoint.type' | translate }}</label>
          <select appSelect [collection]="meteringPointTypeOptions" formControlName="meteringPointType">
          </select>
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'vee.meteringpoint.meteringPointId' | translate }}</label>
          <input type="text" appInput formControlName="meteringPointIdentification"
                 [placeholder]="'vee.meteringpoint.meteringPointId' | translate">
        </app-input-group>
      </div>
      <div class="w-1/4"></div>
      <div class="w-1/4"></div>
    </div>
    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'vee.meteringpoint.streetName' | translate }}</label>
          <input type="text" appInput formControlName="streetName"
                 [placeholder]="'vee.meteringpoint.streetName' | translate">
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'vee.meteringpoint.streetNumber' | translate }}</label>
          <input type="text" appInput formControlName="streetNumber"
                 [placeholder]="'vee.meteringpoint.streetNumber' | translate">
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'vee.meteringpoint.postalCode' | translate }}</label>
          <input appInput inputmode="numeric" pattern="[0-9]*" formControlName="postalCode" [placeholder]="'vee.meteringpoint.postalCode' | translate">
        </app-input-group>
      </div>
      <div class="w-1/4"></div>
    </div>
    <div>
      <button appButton (click)="table.search()" [disabled]="!searchForm.valid">
        {{ 'common.search' | translate }}
      </button>
    </div>
  </form>
</app-card>

<app-table
  #table
  [config]="tableConfig"
  [(selectedElements)]="selectedElements"
></app-table>
